var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C20.1473 0 0 20.3712 0 45.5C0 70.6288 20.1473 91 45 91C69.8526 91 90 70.6288 90 45.5C90 20.3712 69.8526 0 45 0ZM33.3384 24.4146C34.1842 24.3953 35.0583 24.6062 35.9108 25.0736L63.3499 41.1303C64.8432 42.0073 65.8537 43.6171 65.8537 45.5C65.8537 47.3829 64.8432 48.9926 63.3499 49.8697L35.9108 65.9264C32.5008 67.7957 28.6233 65.4139 28.5366 61.4874V29.4779C28.6015 26.5329 30.8011 24.4724 33.3384 24.4146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b17ba1f77f716a46cb9cd0253c666d4c.svg";
export { ForwardRef as ReactComponent };